import React from 'react';

const SingleTimeline = ({ year, title, subTitle, content }) => {
  return (
    <li class='time-line-item'>
      <span
        class='badge badge-primary'
        style={{ background: 'rebeccapurple', fontSize: '20px' }}
      >
        {title}
      </span>
      <h6 class='time-line-item-title' style={{ fontSize: '19px' }}>
        {subTitle}
      </h6>
      <p class='time-line-item-subtitle' style={{ fontSize: '17px' }}>
        {year}
      </p>
      {content && <p class='time-line-item-content'>{content}</p>}
    </li>
  );
};

export default function Timeline({ content }) {
  return (
    <ul class='time-line'>
      {content &&
        content.map((data) => (
          <SingleTimeline
            year={data['year']}
            title={data['title']}
            subTitle={data['subTitle']}
          />
        ))}
    </ul>
  );
}
